export const RadiusNone = "0";
export const RadiusSmall = "0.1875rem";
export const RadiusMedium = "0.3125rem"; // Default value
export const RadiusLarge = "0.5rem";
export const RadiusPill = "3.125rem";
export const GrayWarm1 = "#f9f7f3"; // UI Background option
export const GrayWarm2 = "#f5f3eb"; // UI Background option
export const GrayWarm3 = "#ece9df"; // UI Background option
export const GrayWarm4 = "#d7d3c9"; // UI Stroke option
export const GrayWarm5 = "#b5b2aa"; // UI Stroke option
export const GrayWarm6 = "#88827e"; // UI Stroke option
export const GrayWarm7 = "#6f6765"; // UI Text option
export const GrayWarm8 = "#574e4c"; // UI Text option
export const GrayWarm9 = "#413735"; // UI Text option
export const GrayWarm10 = "#201515"; // UI Text option
export const BrandOrange = "#ff4f00";
export const BrandEarth = "#201515";
export const BrandLavender = "#c1b7ff";
export const BrandNight = "#2b2358";
export const BrandAlmostWhite = "#fffdf9";
export const BrandPeach = "#ffbf6e";
export const BrandCream = "#fff3e6";
export const BrandBolt = "#f6ffdb";
export const BrandNeon = "#ddff76";
export const BrandSky = "#cde4e1";
export const BrandMoss = "#1f3121"; // Unused in product
export const ColorPurple1 = "#f7f6fd";
export const ColorPurple2 = "#d5d7fc";
export const ColorPurple3 = "#847dfe";
export const ColorPurple4 = "#695be8";
export const ColorPurple5 = "#503ebd";
export const ColorYellow1 = "#fff8d9"; // Background (min 4.5:1 contrast against 4 Text)
export const ColorYellow2 = "#f4db6f"; // Background (min 4.5:1 contrast against text default)
export const ColorYellow3 = "#a88d10"; // Stroke (3:1 contrast against background default)
export const ColorYellow4 = "#86700b"; // Text (4.5:1 contrast against background default)
export const ColorYellow5 = "#645304"; // Hover (7:1 contrast against background default)
export const ColorRed1 = "#fff2ef"; // Background (min 4.5:1 contrast against 4 Text)
export const ColorRed2 = "#fdc9c6"; // Background (min 4.5:1 contrast against text default)
export const ColorRed3 = "#f65258"; // Stroke (3:1 contrast against background default)
export const ColorRed4 = "#d12d37"; // Text (4.5:1 contrast against background default)
export const ColorRed5 = "#a81227"; // Hover (7:1 contrast against background default)
export const ColorBlue1 = "#f0f8fc"; // Background (min 4.5:1 contrast against 4 Text)
export const ColorBlue2 = "#aee1fd"; // Background (min 4.5:1 contrast against text default)
export const ColorBlue3 = "#3298c7"; // Stroke (3:1 contrast against background default)
export const ColorBlue4 = "#1979a2"; // Text (4.5:1 contrast against background default)
export const ColorBlue5 = "#035a7b"; // Hover (7:1 contrast against background default)
export const ColorOrange1 = "#fdf7f2"; // Background (min 4.5:1 contrast against 4 Text)
export const ColorOrange2 = "#fdd0ae"; // Background (min 4.5:1 contrast against text default)
export const ColorOrange3 = "#d57601"; // Stroke (3:1 contrast against background default)
export const ColorOrange4 = "#aa5f0e"; // Text (4.5:1 contrast against background default)
export const ColorOrange5 = "#7b4714"; // Hover (7:1 contrast against background default)
export const ColorTeal1 = "#e4fbf7"; // Background (min 4.5:1 contrast against 4 Text)
export const ColorTeal2 = "#a1e5dd"; // Background (min 4.5:1 contrast against text default)
export const ColorTeal3 = "#1a9f94"; // Stroke (3:1 contrast against background default)
export const ColorTeal4 = "#0f7e75"; // Text (4.5:1 contrast against background default)
export const ColorTeal5 = "#125f58"; // Hover (7:1 contrast against background default)
export const ColorGreen1 = "#e7ffe7"; // Background (min 4.5:1 contrast against 4 Text)
export const ColorGreen2 = "#a7eaaa"; // Background (min 4.5:1 contrast against text default)
export const ColorGreen3 = "#2ea343"; // Stroke (3:1 contrast against background default)
export const ColorGreen4 = "#0a842a"; // Text (4.5:1 contrast against background default)
export const ColorGreen5 = "#156123"; // Hover (7:1 contrast against background default)
export const ColorPink1 = "#fdf6fb"; // Background (min 4.5:1 contrast against 4 Text)
export const ColorPink2 = "#feccf2"; // Background (min 4.5:1 contrast against text default)
export const ColorPink3 = "#d367bd"; // Stroke (3:1 contrast against background default)
export const ColorPink4 = "#aa509a"; // Text (4.5:1 contrast against background default)
export const ColorPink5 = "#7c3e70"; // Hover (7:1 contrast against background default)
export const PrimeWhite = "#fffdf9";
export const PrimeBlack = "#201515";
export const PrimePurple = "#847dfe";
export const PrimeBlue = "#3298c7";
export const PrimeTeal = "#1a9f94";
export const PrimeGreen = "#2ea343";
export const PrimeYellow = "#a88d10";
export const PrimeOrange = "#d57601";
export const PrimeRed = "#f65258";
export const PrimePink = "#d367bd";
export const Size2 = "0.125rem";
export const Size4 = "0.25rem";
export const Size8 = "0.5rem";
export const Size16 = "1rem";
export const Size20 = "1.25rem";
export const Size24 = "1.5rem";
export const Size32 = "2rem";
export const Size36 = "2.25rem";
export const Size40 = "2.5rem";
export const Size48 = "3rem";
export const Space0 = "0";
export const Space2 = "0.125rem";
export const Space4 = "0.25rem";
export const Space6 = "0.375rem"; // Applied only inside a component
export const Space8 = "0.5rem";
export const Space12 = "0.75rem";
export const Space16 = "1rem";
export const Space20 = "1.25rem";
export const Space24 = "1.5rem";
export const Space28 = "1.75rem";
export const Space32 = "2rem";
export const Space36 = "2.25rem";
export const Space40 = "2.5rem";
export const Space44 = "2.75rem";
export const Space48 = "3rem";
export const PageHeader = "600 2.25rem/3rem 'Degular Display', var(--zds-typography-heading-display, Helvetica), Helvetica, arial, sans-serif";
export const SectionHeader = "600 1.5rem/2.25rem 'Degular Display', var(--zds-typography-heading-display, Helvetica), Helvetica, arial, sans-serif";
export const SectionHeaderMultiline = "600 1.5rem/2rem 'Degular Display', var(--zds-typography-heading-display, Helvetica), Helvetica, arial, sans-serif";
export const ParagraphHeader4 = "700 1.125rem/1.5rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const ParagraphHeader3 = "600 1.125rem/1.5rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const ParagraphHeader2 = "500 1.125rem/1.5rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const ParagraphHeader1 = "400 1.125rem/1.5rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const Title = "600 1rem/1.25rem 'Degular Display', var(--zds-typography-heading-display, Helvetica), Helvetica, arial, sans-serif";
export const Body4 = "700 0.875rem/1.5rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const Body4Multiline = "700 0.875rem/1.25rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const Body3 = "600 0.875rem/1.5rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const Body3Multiline = "600 0.875rem/1.25rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const Body2 = "500 0.875rem/1.5rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const Body2Multiline = "500 0.875rem/1.25rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const Body1 = "400 0.875rem/1.5rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const Body1Multiline = "400 0.875rem/1.25rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const SmallPrint4 = "700 0.8125rem/1.25rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const SmallPrint4Multiline = "700 0.8125rem/1rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const SmallPrint3 = "600 0.8125rem/1.25rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const SmallPrint3Multiline = "600 0.8125rem/1rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const SmallPrint2 = "500 0.8125rem/1.25rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const SmallPrint2Multiline = "500 0.8125rem/1rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const SmallPrint1 = "400 0.8125rem/1.25rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const SmallPrint1Multiline = "400 0.8125rem/1rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const MinimalPrint4 = "700 0.75rem/1.25rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const MinimalPrint4Multiline = "700 0.75rem/1rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const MinimalPrint3 = "600 0.75rem/1.25rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const MinimalPrint3Multiline = "600 0.75rem/1rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const MinimalPrint2 = "500 0.75rem/1.25rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const MinimalPrint2Multiline = "500 0.75rem/1rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const MinimalPrint1 = "400 0.75rem/1.25rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const MinimalPrint1Multiline = "400 0.75rem/1rem Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif";
export const ShadowSurface = "0 1px 18px 0 rgba(20,15,15,0.12), 0 6px 10px 0 rgba(20,15,15,0.14), 0 3px 5px -1px rgba(20,15,15,0.2)";
export const GradientGradient1 = "linear-gradient(140deg, #ffbf6e 0%, #FEA048 26%, #FF7F24 39%, #ff4f00 50%, #FF5789 61%, #F589DC 74%, #c1b7ff 100%)"; // Peach - Orange - Lavender
export const UiBrandWeakest = "#fdf5f2";
export const UiBrandWeaker = "#fed1c3"; // Old value: #FFB999
export const UiBrand = "#ff4f00";
export const UiBrandStronger = "#cc3f00";
export const UiBrandStrongest = "#993109";
export const UiPrimaryWeakest = "#f7f6fd";
export const UiPrimaryWeaker = "#d5d7fc";
export const UiPrimary = "#847dfe";
export const UiPrimaryStronger = "#695be8";
export const UiPrimaryStrongest = "#503ebd";
export const StatusWarningWeakest = "#fff8d9";
export const StatusWarningWeaker = "#f4db6f";
export const StatusWarning = "#a88d10";
export const StatusWarningStronger = "#86700b";
export const StatusWarningStrongest = "#645304";
export const StatusErrorWeakest = "#fff2ef";
export const StatusErrorWeaker = "#fdc9c6";
export const StatusError = "#f65258";
export const StatusErrorStronger = "#d12d37";
export const StatusErrorStrongest = "#a81227";
export const StatusSuccessWeakest = "#e7ffe7";
export const StatusSuccessWeaker = "#a7eaaa";
export const StatusSuccess = "#2ea343";
export const StatusSuccessStronger = "#0a842a";
export const StatusSuccessStrongest = "#156123";
export const RadiusDefault = "0.3125rem";
export const BackgroundWeaker = "#fffdf9";
export const BackgroundDefault = "#f9f7f3";
export const BackgroundStronger = "#f5f3eb";
export const BackgroundStrongest = "#ece9df";
export const BackgroundSelected = "#f7f6fd";
export const BackgroundOverlay = "rgb(12.5% 8.24% 8.24% / 0.8)"; // Background for elements displayed on top of the UI
export const StrokeWeaker = "#d7d3c9";
export const StrokeDefault = "#b5b2aa";
export const StrokeStronger = "#88827e";
export const StrokeSelected = "#847dfe";
export const ReservedBeta = "#d5d7fc";
export const ReservedInvite = "#f6ffdb";
export const ReservedFree = "#1a9f94";
export const ReservedAi = "linear-gradient(140deg, #ffbf6e 0%, #FEA048 26%, #FF7F24 39%, #ff4f00 50%, #FF5789 61%, #F589DC 74%, #c1b7ff 100%)";
export const TextWeakest = "#6f6765";
export const TextWeaker = "#574e4c";
export const TextDefault = "#413735";
export const TextStronger = "#201515";
export const TextLink = "#695be8";
export const TextLinkHover = "#503ebd";
export const TextInverted = "#fffdf9";
export const SizeXsmall = "1.25rem";
export const SizeSmall = "1.5rem";
export const SizeMedium = "2.25rem";
export const SizeLarge = "3rem";
export const BorderWidthDefault = "0.0625rem";
export const BorderWidthStrong = "0.125rem";
export const BorderWeak = "0.0625rem solid #d7d3c9";
export const BorderDefault = "0.0625rem solid #b5b2aa";
export const BorderFocus = "0.125rem solid #695be8";
export const Inter = "Inter, var(--zds-typography-base, Helvetica), Helvetica, arial, sans-serif"; // Body copy font
export const Degular = "'Degular Display', var(--zds-typography-heading-display, Helvetica), Helvetica, arial, sans-serif"; // Big heading
export const SemiboldDegular = 600;
export const Medium = 500;
export const Regular = 400;
export const SemiBoldInter = 600;
export const Bold = 700;
export const LineHeightLarge = "3rem";
export const LineHeightMedium = "2.25rem";
export const LineHeightMediumMultiline = "2rem";
export const LineHeightSmall = "1.5rem";
export const LineHeightSmallMultiline = "1.25rem";
export const LineHeightXsmall = "1.25rem";
export const LineHeightXsmallMultiline = "1rem";
export const LetterSpacingHeader = "0.0625rem";
export const FontSizeHeaderXlarge = "2.25rem";
export const FontSizeHeaderLarge = "1.5rem";
export const FontSizeHeader = "1.125rem";
export const FontSizeTitle = "1rem"; // Marketing purpose
export const FontSizeDefault = "0.875rem";
export const FontSizeSmallPrint = "0.8125rem";
export const FontSizeMinimal = "0.75rem";
